const { useEffect } = React;

function Footer() {
    const currentYear = new Date().getFullYear();

    useEffect(() => {
        if (typeof lucide !== "undefined" && lucide.createIcons) {
            lucide.createIcons();
        }
    }, []);

    return (
        <footer className="relative bg-transparent border-t border-blue-100/20 overflow-hidden">
            {/* Decorative Background */}
            <div className="absolute inset-0 opacity-20">
                <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20"></div>
            </div>

            <div className="relative z-10">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
                        {/* Brand Section */}
                        <div className="md:col-span-1">
                            <a href="#home" className="text-2xl font-bold text-gradient mb-4 inline-block">
                                BEASMAR
                            </a>
                            <p className="text-gray-600 mt-4 text-sm leading-relaxed">
                                The future of open house booking. Connecting seekers with verified realtors.
                            </p>
                            <div className="flex gap-4 mt-6">
                                {[
                                    { icon: "facebook", label: "Facebook" },
                                    { icon: "twitter", label: "Twitter" },
                                    { icon: "linkedin", label: "LinkedIn" },
                                    { icon: "instagram", label: "Instagram" },
                                ].map((social) => (
                                    <a
                                        key={social.label}
                                        href="#"
                                        className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-600/10 to-blue-400/10 border border-blue-300/30 flex items-center justify-center text-blue-600 hover:bg-blue-600 hover:text-white hover:shadow-lg hover:shadow-blue-500/30 transition-all duration-300"
                                        title={social.label}
                                    >
                                        <i data-lucide={social.icon} className="w-5 h-5"></i>
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div>
                            <h4 className="font-semibold text-gray-900 mb-4">Quick Links</h4>
                            <ul className="space-y-3">
                                {[
                                    { text: "Home", href: "/" },
                                    { text: "About", href: "#about" },
                                    { text: "How It Works", href: "#how-it-works" },
                                    { text: "Pricing", href: "#pricing" },
                                    { text: "Features", href: "#advantages" },
                                ].map((link) => (
                                    <li key={link.text}>
                                        <a href={link.href} className="nav-link text-sm">
                                            {link.text}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* For Everyone */}
                        <div>
                            <h4 className="font-semibold text-gray-900 mb-4">For Everyone</h4>
                            <ul className="space-y-3">
                                {[
                                    { text: "Client Portal", href: "customer.html" },
                                    { text: "Realtor Portal", href: "agent.html" },
                                    { text: "Pricing", href: "#pricing" },
                                    { text: "FAQ", href: "#" },
                                ].map((link) => (
                                    <li key={link.text}>
                                        <a href={link.href} className="nav-link text-sm">
                                            {link.text}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Legal */}
                        <div>
                            <h4 className="font-semibold text-gray-900 mb-4">Legal</h4>
                            <ul className="space-y-3">
                                {[
                                    { text: "Privacy Policy", href: "#" },
                                    { text: "Terms of Service", href: "#" },
                                    { text: "Contact", href: "#" },
                                    { text: "Support", href: "#" },
                                ].map((link) => (
                                    <li key={link.text}>
                                        <a href={link.href} className="nav-link text-sm">
                                            {link.text}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="border-t border-blue-100/20 pt-8">
                        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                            <p className="text-gray-600 text-sm">
                                &copy; {currentYear} BEASMAR. All rights reserved.
                            </p>
                            <div className="flex gap-6 text-sm">
                                <a href="#" className="nav-link text-sm">Privacy</a>
                                <a href="#" className="nav-link text-sm">Terms</a>
                                <a href="#" className="nav-link text-sm">Cookies</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;

